import { call, put, takeEvery } from 'redux-saga/effects';
import { LogisticsActionKeys, UpdateWarehouse } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { IWarehouse, lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateWarehouse } from '../logisticsApi';

function* updateWarehouseSaga(action: UpdateWarehouse) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IWarehouse> = yield call(updateWarehouse, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ partial: true, payload: { warehouses: [response.value] } }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateWarehouse() {
  yield takeEvery(LogisticsActionKeys.UPDATE_WAREHOUSE, updateWarehouseSaga);
}
